export default "<div class=\"ion-text-center\">\n  {{ 'component.order-countdown-timer.countdown-text' | translate }} {{ timeDisplay }}\n</div>";